var map = {
	"./403.svg": 61172,
	"./404.svg": 94235,
	"./VIPcenter.svg": 17145,
	"./VIPcenterfalse-dark.svg": 55679,
	"./VIPcenterfalse-darkfalse.svg": 14936,
	"./VIPcenterfalse.svg": 17414,
	"./ai_menu_icon.svg": 92957,
	"./arrow-blue.svg": 9737,
	"./arrow_down.svg": 9375,
	"./azure_login_redirect_back_waiting.svg": 22007,
	"./beforePage.svg": 10197,
	"./bug.svg": 92813,
	"./chart.svg": 13751,
	"./clearance-choose-dark.svg": 6878,
	"./clearance-choose-darkfalse.svg": 7267,
	"./clearance-choose.svg": 37781,
	"./clearance-choosefalse.svg": 60322,
	"./clearance.svg": 60821,
	"./clearancefalse-dark.svg": 7571,
	"./clearancefalse.svg": 53314,
	"./clipboard.svg": 96889,
	"./component.svg": 10250,
	"./dashboard.svg": 4679,
	"./delete.svg": 94928,
	"./documentation.svg": 23397,
	"./drag.svg": 28715,
	"./edit.svg": 95869,
	"./editIcon.svg": 89594,
	"./education.svg": 3937,
	"./email.svg": 39083,
	"./example.svg": 21649,
	"./excel.svg": 42474,
	"./exit-fullscreen.svg": 54861,
	"./eye-open.svg": 12429,
	"./eye.svg": 95628,
	"./faq.svg": 4475,
	"./form.svg": 3771,
	"./fullscreen.svg": 6638,
	"./guide.svg": 47987,
	"./icon-create.svg": 64671,
	"./icon-delete.svg": 77022,
	"./icon-edit1.svg": 18024,
	"./icon.svg": 92814,
	"./international.svg": 5091,
	"./language.svg": 5247,
	"./link.svg": 81445,
	"./list.svg": 99161,
	"./lock.svg": 52636,
	"./login.svg": 69376,
	"./manager.svg": 45150,
	"./message.svg": 38166,
	"./money.svg": 49659,
	"./nested.svg": 85016,
	"./nextto.svg": 17789,
	"./password.svg": 39902,
	"./pdf.svg": 38001,
	"./people.svg": 34952,
	"./peoples.svg": 46779,
	"./port-add.svg": 68402,
	"./profile.svg": 53308,
	"./profile_normal.svg": 86274,
	"./profilefalse-dark.svg": 87286,
	"./profilefalse.svg": 40797,
	"./qq.svg": 75951,
	"./search.svg": 58217,
	"./shopping.svg": 65697,
	"./size.svg": 88334,
	"./skill.svg": 92160,
	"./staff.svg": 28221,
	"./stafffalse-dark.svg": 83787,
	"./stafffalse.svg": 90314,
	"./star.svg": 48637,
	"./status_query.svg": 70126,
	"./status_query_select.svg": 29925,
	"./tab.svg": 94598,
	"./table.svg": 54383,
	"./theme.svg": 88972,
	"./tree-table.svg": 41622,
	"./tree.svg": 92701,
	"./user.svg": 68848,
	"./wechat.svg": 80719,
	"./zip.svg": 71902
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;